import {NavLink as SourceNavLink} from 'react-router-dom';
import styled from 'styled-components';

import {border, colors} from 'theme';

export const NavBar = styled.nav<{
    flexGrow?: boolean;
}>`
    ${(p) => p.flexGrow && 'flex: 1;'}
    display: flex;
    justify-content: center;
    align-items: stretch;
    max-height: 44px;

    a {
        display: flex;
        flex-flow: row nowrap;
        align-items: center;

        text-decoration: none;
    }
`;

export const NavLink = styled(SourceNavLink)`
    padding: 10px 14px;
    font-size: 14px;
    line-height: 16px;
    font-weight: 700;
    color: ${colors.brandPrimary};
    background: ${colors.white};
    border-radius: 0 0 0 0;
    border: 1px solid ${colors.border};
    margin-right: -1px;
    text-transform: uppercase;
    word-break: normal;

    &:first-of-type {
        border-radius: ${border.radius} 0 0 ${border.radius};
    }

    &:last-of-type {
        border-radius: 0 ${border.radius} ${border.radius} 0;
        margin-right: 0;
    }

    &.active {
        color: ${colors.white};
        background: ${colors.brandPrimary};
        border-color: ${colors.brandPrimary};
    }
`;
